module.exports = __webpack_public_path__ + "static/media/emailYourself.a18f944d.jpg";